import { Controller } from "@hotwired/stimulus"

// Stimulus controller for daisyUI .toast notifications. Auto-dismisses after
// `delay-value` ms (default 4000); 0 means "stay open until manually dismissed".
// Click-to-dismiss via [data-action="toast#dismiss"] on a close button.
//
// The fade-out is handled by CSS opacity + transform transitions on the
// element — see `[data-controller='toast']` rules in application.css.
export default class extends Controller {
  static values = { delay: { type: Number, default: 4000 } }
  declare delayValue: number

  private timer?: number

  connect() {
    if (this.delayValue > 0) {
      this.timer = window.setTimeout(() => this.dismiss(), this.delayValue)
    }
  }

  disconnect() {
    if (this.timer) window.clearTimeout(this.timer)
  }

  dismiss() {
    const el = this.element as HTMLElement
    // Trigger the fade-out, then remove the node so it stops occupying space
    // when the next toast appears (the .toast container is fixed-positioned
    // so leaving stale nodes around would stack them).
    el.classList.add("opacity-0", "translate-y-2")
    window.setTimeout(() => el.remove(), 200)
  }
}
